import { z } from 'zod';
export const SummarySchema = z.object({
    text: z.string().nullable(),
    snippet: z.string().nullable()
}).meta({
    id: 'Summary'
});

//# sourceMappingURL=summary.schema.js.map